export const blockIconsContentCreate = (
	<span className='material-symbols-outlined'>create</span>
);
